// Project settings in the right-hand panel (settings cleanup, PR 3).
//
// [data-show-when="name=value"] shows an element only while the control
// called `name` in the same Settings panel has that value ("a|b" for any of
// several, "name!=value" for not). While hidden, its inputs are disabled so
// they are not posted. The server renders the saved state and stays the only
// judge of what is allowed (@app/project-config).
//
// [data-lazy-src="url"] loads a fragment into the element, at once when it is
// visible or when its <details> is first opened (branches and pull requests
// come from GitHub, so Settings itself opens fast).
//
// shell.js calls init(panel) after each load.
(function () {
  'use strict';

  function valueOf(root, name) {
    var els = root.querySelectorAll('[name="' + name + '"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.disabled) continue;
      if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) return el.value; continue; }
      return el.value;
    }
    return '';
  }

  function matches(root, rule) {
    var m = /^([a-z_]+)(!?=)(.*)$/.exec(rule || '');
    if (!m) return true;
    var hit = m[3].split('|').indexOf(valueOf(root, m[1])) >= 0;
    return m[2] === '=' ? hit : !hit;
  }

  function setInputs(el, off) {
    el.querySelectorAll('input, select, textarea, button').forEach(function (i) {
      if (off) {
        if (!i.disabled) { i.disabled = true; i.setAttribute('data-sw-off', ''); }
      } else if (i.hasAttribute('data-sw-off')) {
        i.disabled = false; i.removeAttribute('data-sw-off');
      }
    });
  }

  // Outer rules first, so a nested rule reads its controls after its
  // parent has enabled or disabled them.
  function apply(root) {
    root.querySelectorAll('[data-show-when]').forEach(function (el) {
      var on = matches(root, el.getAttribute('data-show-when'));
      el.hidden = !on;
      setInputs(el, !on);
    });
  }

  function lazy(el) {
    if (el.hasAttribute('data-lazy-done')) return;
    el.setAttribute('data-lazy-done', '');
    fetch(el.getAttribute('data-lazy-src'), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { el.innerHTML = html; })
      .catch(function () { el.innerHTML = '<p class="panel__hint form-error">Could not load this from GitHub right now.</p>'; });
  }

  function init(panel) {
    var root = panel.querySelector('[data-settings]');
    if (!root) return;
    apply(root);
    if (!root.hasAttribute('data-sw-bound')) {
      root.setAttribute('data-sw-bound', '');
      root.addEventListener('change', function () { apply(root); });
      root.addEventListener('toggle', function (e) {
        if (e.target.open) e.target.querySelectorAll('[data-lazy-src]').forEach(lazy);
      }, true);
    }
    root.querySelectorAll('[data-lazy-src]').forEach(function (el) {
      var d = el.closest('details');
      if (!d || d.open) lazy(el);
    });
  }

  window.RushworksSettings = { init: init, apply: apply, matches: matches };
})();
